import { Select } from 'antd';
import React from 'react';
import { FilterOptionsWrapper } from 'ui/Filter';

function SelectTableFilter({
  dataSourse = [],
  value,
  itemKey = 'key',
  itemValue = 'value',
  placeholder,
  getSelectedItem,
  multiple = false,
  style = null,
}) {
  const defaultStyle = { width: '180px' };

  return (
    <FilterOptionsWrapper>
      <Select
        allowClear
        showArrow
        showSearch
        mode={multiple ? 'multiple' : ''}
        optionFilterProp="children"
        value={value}
        placeholder={placeholder}
        onChange={getSelectedItem}
        style={style || defaultStyle}
      >
        {dataSourse.map((item) => (
          <Select.Option key={item[itemKey]} value={item[itemKey]}>
            {item[itemValue]}
          </Select.Option>
        ))}
      </Select>
    </FilterOptionsWrapper>
  );
}

export { SelectTableFilter };
